<div id="accordion">
    <ValidationObserver v-slot="{ handleSubmit  }" ref="formRef">
        <form @submit.prevent>
            <div class="card najiz-card-panel mb-10">
                <div class="card-header najiz-panel-header" id="headingOne">
                    <h4 class="mb-0 py-3"><b>مدة العقد</b></h4>
                </div>
                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                        <div class="form-row">
                            <div class="col-lg-4 col-md-6 col-sm-12">
                                <validation-provider v-slot="{ errors }" name="contractStartDate" rules="required|date">
                                    <v-input :error-messages="errors" v-model="contractStartDate.gregDate">
                                        <DropDownCalendarComponent :key="startDateKey" isRequired="true"
                                            label="تاريخ بداية العقد" :isGregorian="contractStartDate.isGregorian"
                                            :futureYearsCount="1" minDate="today"
                                            :selectedDate="contractStartDate.isGregorian ? contractStartDate.gregDate : contractStartDate.hijriDate"
                                            @dateChanged="onStartDateChanged">
                                        </DropDownCalendarComponent>
                                    </v-input>
                                </validation-provider>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-lg-4 col-md-6 col-sm-12">
                                <validation-provider v-slot="{ errors }" name="contractEndDate"
                                    :rules="`required|date|minimumContractDuration:${contractStartDate.gregDate}`">
                                    <v-input :error-messages="errors" v-model="contractEndDate.gregDate">
                                        <DropDownCalendarComponent :key="contractStartDate.hijriDate" :isRequired="true"
                                            label="تاريخ انتهاء العقد" :yearsCount="100"
                                            :isGregorian="contractEndDate.isGregorian" :futureYearsCount="15"
                                            :minDate="contractStartDate.hijriDate"
                                            :selectedDate="contractEndDate.isGregorian ? contractEndDate.gregDate : contractEndDate.hijriDate"
                                            @dateChanged="onEndDateChangedDate">
                                        </DropDownCalendarComponent>
                                    </v-input>
                                </validation-provider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr class="footer-hr" />
            <div class="d-flex">
                <button type="button" class="btn btn-link text-danger ml-auto pr-0 text-decoration-none"
                    @click="onCancel">إلغاء</button>
                <button type="button" class="btn btn-outline-primary mx-4 px-8" @click="previousStep">السابق</button>
                <button type="submit" class="btn button--greenFill px-8" @click="handleSubmit(nextStep)">التالي</button>
            </div>
        </form>
    </ValidationObserver>
</div>